import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styles from './Payment.module.scss';

const REASON_MESSAGE: Record<string, string> = {
  cancel: '결제가 취소되었습니다.',
  fail: '결제에 실패했습니다.',
  invalid: '결제 요청 정보가 올바르지 않습니다.',
  not_found: '주문 정보를 찾을 수 없습니다.',
  approve_failed: '결제 승인에 실패했습니다.',
  invalid_status: '결제할 수 없는 주문 상태입니다. 결제가 승인됐다면 자동으로 취소됩니다.',
  amount_mismatch: '결제 금액이 주문 금액과 달라 결제가 취소되었습니다. 다시 시도해주세요.',
};

function PaymentFail() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') ?? '';
  const orderId = searchParams.get('orderNo');
  const detail = searchParams.get('detail');
  const message = REASON_MESSAGE[reason] ?? '결제가 취소되었거나 실패했습니다.';

  // 서버가 넘겨준 PG 실패 사유를 콘솔에 남겨 원인을 확인할 수 있게 한다
  useEffect(() => {
    console.error('[결제 실패]', { reason, orderNo: orderId, detail });
  }, [reason, orderId, detail]);

  return (
    <div className={styles.page}>
      <section className={styles.card}>
        <span className={`${styles.badge} ${styles.badgeFail}`} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </span>
        <span className={styles.eyebrow}>Payment Failed</span>
        <h1 className={styles.title}>결제 실패</h1>
        {orderId && (
          <p className={styles.orderNo}>
            주문번호<strong>{orderId}</strong>
          </p>
        )}
        <p className={styles.desc}>{message}</p>
        <Link to="/mypage" className={styles.cta}>
          마이페이지로
        </Link>
      </section>
    </div>
  );
}

export default PaymentFail;
